export default __webpack_public_path__ + "static/zaklepschronisko-promo@1x-0c52f915c6cf47e0c88d68b7c50c49c5.jpg";